export const StyleBase = {

    paperWidth: 800,
    paperHeight: 600,

    sidebarWidth: 120

};